// GenerateEmptyState — estado vacío del Generate (sin posts aún): guía de 3
// pasos para crear el primer contenido. Presentacional; solo necesita el
// workspaceId para el link a la página Brand.
import { Link } from 'react-router-dom';
import { EmptyState } from './styled';

interface Props {
  workspaceId?: string;
}

export function GenerateEmptyState({ workspaceId }: Props) {
  return (
    <EmptyState>
      <div style={{ maxWidth: 480, margin: '0 auto', textAlign: 'left' }}>
        <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 12, textAlign: 'center' }}>
          Create your first content in 3 steps
        </h3>
        <ol style={{ margin: 0, paddingLeft: 22, lineHeight: 1.7, color: '#475569' }}>
          <li>
            <strong>Complete your brand</strong> — colors, tone and business info. That's what the AI
            uses to write better.{' '}
            <Link to={`/workspace/${workspaceId}/brand`}>Go to Brand →</Link>
          </li>
          <li>
            <strong>(Optional) Upload photos</strong> in the Brand page (Assets tab) so your posts have
            more variety.
          </li>
          <li>
            <strong>Configure and generate</strong> — pick networks and counts on the side (or ask Novah)
            and hit <em>Generate</em>.
          </li>
        </ol>
      </div>
    </EmptyState>
  );
}
